const STRIPE_DISABLED_FOR_SUBSCRIBERS_PARTIALLY_KEY =
  'persona_disable_stripe_for_subscribers_partially'

export const isStripeDisabledForSubscribersPartially = (
  experiments: Record<string, string | null | undefined>,
) =>
  experiments[STRIPE_DISABLED_FOR_SUBSCRIBERS_PARTIALLY_KEY]?.includes(
    'variant',
  ) || false
